export function numberOfAssignedSsns(enoteDocument) {
  return enoteDocument.mortgageBorrowers.totalCount > 0
    ? (enoteDocument.mortgageBorrowers.edges || []).reduce((sum, { node }) => {
        return node.hasSsn ? sum + 1 : sum;
      }, 0)
    : 0;
}
